import { Permissao } from '../types/permissao.type';
import api from './api';

export interface Cargo {
  id: number;
  nome: string;
  descricao?: string;
}
export interface CreateCargoDTO {
  nome: string;
  descricao?: string;
  permissaoIds: number[];
  permissoes?: Permissao[];
}

export type UpdateCargoDTO = Partial<CreateCargoDTO>;

const listarCargos = async (): Promise<Cargo[]> => {
  const response = await api.get<Cargo[]>('/cargos');
  console.log(response.data);
  return response.data;
};


const criarCargo = async (data: CreateCargoDTO): Promise<Cargo> => {
  const response = await api.post<Cargo>('/cargos', data);
  return response.data;
};

const atualizarCargo = async (id: number, data: UpdateCargoDTO): Promise<Cargo> => {
  const response = await api.put<Cargo>(`/cargos/${id}`, data);
  return response.data;
};

const excluirCargo = async (id: number): Promise<void> => {
  await api.delete(`/cargos/${id}`);
};

export const cargoService = {
  listarCargos,
  criarCargo,
  atualizarCargo,
  excluirCargo,
};
